<template>
    <layout-authenticated>
        <v-breadcrumbs :items="breadcrumb"></v-breadcrumbs>
        <h1 class="mb-3">{{ $t('buyers.buyer_addresses') }}</h1>
        <buyer-addresses-table v-if="warehouseId != null" :buyer-id="buyerId" :warehouse-id="warehouseId"/>
    </layout-authenticated>
</template>

<script>
import LayoutAuthenticated from "@/layouts/LayoutAuthenticated";
import BuyerAddressesTable from "@/components/user/buyers/BuyerAddressesTable";
import _ from "lodash";

export default {
    name: "BuyerAddresses",
    components: {BuyerAddressesTable, LayoutAuthenticated},
    computed: {
        breadcrumb() {
            return [
                {
                    text: this.$t('app.name'),
                    href: '/'
                },
                {
                    text: this.$t('buyers.buyers'),
                    href: '/buyers',
                },
                {
                    text: this.$t('buyers.buyer_addresses'),
                    href: '/buyers/' + this.buyerId + '/addresses',
                    disabled: true
                }
            ];
        },
        buyerId() {
            return _.toInteger(this.$route.params.buyerId);
        },
        warehouseId() {
            const userId = this.$store.getters['identity/getUserId'];
            return this.$store.getters['warehouse/getWarehouseId'](userId);
        }
    }
}
</script>
